import React, { FC, ReactElement } from 'react';
import { EventCardComponentsProps } from './types';

const EventCardInfo: FC<EventCardComponentsProps> = ({ children, className }): ReactElement => {
  return (
    <div className={className}>{children}</div>
  );
};

export { EventCardInfo };